// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"41f0755b","361":"03a2870e","511":"14f277bb","767":"08b14e08"}[chunkId] + ".chunk.js";
};